import { Redirect, Route } from 'react-router-dom';

import { getFirebase } from 'react-redux-firebase';
import { ROUTES_MAP } from '../config/routes';
import useAuthChecker from '../hooks/useAuthChecker';
import useRedirect from '../hooks/useRedirect';
import type { AuthConfig } from '../types/auth';

interface RouteGuardProps {
  children: React.ReactNode;
  auth?: AuthConfig;
  path: string;
  redirect?: string;
}

const RouteGuard = ({
  children,
  auth,
  path,
  redirect,
  ...rest
}: RouteGuardProps) => {
  const { isAuthed, isChecking, noRoles } = useAuthChecker(auth, undefined);
  const redirectTo = useRedirect(redirect);
  const firebase = getFirebase();

  if (isChecking) {
    // console.log(path, 'RouteGuard isChecking status...');
    return null;
  }

  if (noRoles) {
    firebase.logout();
    return <Redirect to={ROUTES_MAP.LOGIN.path} />;
  }

  if (isAuthed) {
    // console.log(path, 'RouteGuard isAuthed so show children');
    return <Route {...rest} render={() => children} />;
  }

  if (!isAuthed && redirectTo) {
    // console.log(path, 'RouteGuard is NOT Authed so redirect to', redirectTo);
    return <Redirect to={redirectTo} />;
  }

  return null;
};

export default RouteGuard;
